import React from 'react';

interface Panel {
  children?: React.ReactNode;
  classNames?: string;
  background?: string;
  bordered?: boolean;
}

export const Panel = ({
  children,
  classNames,
  bordered = false,
  background = 'bg-gray-50 dark:bg-slate-800',
}: Panel) => {
  return (
    <div
      className={`px-3 py-3 relative flex items-center ${bordered ? 'border border-gray-200 dark:border-gray-700 p-4 rounded-md' : ''} ${background} rounded ${classNames}`}
    >
      <div className="w-full">{children}</div>
    </div>
  );
};

export default Panel;
